
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/underwear-and-loungewear",
      function () {
        return require("private-next-pages/apparel/underwear-and-loungewear/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/underwear-and-loungewear"])
      });
    }
  